import { render, staticRenderFns } from "./CurrentProductsOverview.vue?vue&type=template&id=fb199f62&scoped=true&"
import script from "./CurrentProductsOverview.vue?vue&type=script&lang=js&"
export * from "./CurrentProductsOverview.vue?vue&type=script&lang=js&"
import style0 from "./CurrentProductsOverview.vue?vue&type=style&index=0&id=fb199f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb199f62",
  null
  
)

export default component.exports